import { TEDCustomNumberDisplayer } from './TEDCustomNumberDisplayer';
import { TEDParseNumberMode } from '../FormatterTypes';

class TEDDisplayCurr extends TEDCustomNumberDisplayer {
  public static getInstance() {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayCurr;

  mode(): TEDParseNumberMode {
    return TEDParseNumberMode.pnmCurrency;
  }
}

export { TEDDisplayCurr };
